import { render, staticRenderFns } from "./AgentOrder.vue?vue&type=template&id=28b95851"
import script from "./AgentOrder.vue?vue&type=script&lang=js"
export * from "./AgentOrder.vue?vue&type=script&lang=js"
import style0 from "./AgentOrder.vue?vue&type=style&index=0&id=28b95851&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports